import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, tap, filter, catchError, mergeMap} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {BASE_URL} from '../../config/config';
import { NgxSpinnerService } from "ngx-spinner";
import {AuthService} from './../../login/auth.service';
import {Router} from '@angular/router';


@Injectable()

export class DashboardService {

  public DASBOARD_URL = BASE_URL.URL;
  private userId: any;
  private token: any;


  constructor(private http: HttpClient, private spinnerService: NgxSpinnerService, private authService: AuthService, private route: Router) {
  }

  getDashBoard(): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token')
    };
    // @ts-ignore
    return this.http.post(this.DASBOARD_URL + '/dashboard/data', param)
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getDashBoardById(): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token')
    };
    return this.http.post(this.DASBOARD_URL + '/dashboard/body_parts', param)
    .pipe(
      map(res => res),
      tap(() => this.spinnerService.hide()),
      catchError(this.handleError.bind(this))
    )
  }

  getImplants(e): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token'),
      body_part_id: e
    };
    return this.http.post(this.DASBOARD_URL + `/dashboard/load_implants`, param)
      .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
  }

  getModalImplantData(id, bodyId): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token'),
      implant_id: id,
      body_id: bodyId
    };
    return this.http.post(this.DASBOARD_URL + `/dashboard/product_categories`, param)
      .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
  }

  getModalListOfProducts(implid, prodid, page): Observable<any> {    
    const param = {
      token: localStorage.getItem('token'),
      implant_id: implid,
      product_category_id: prodid,
      page
    };

    return this.http.post(this.DASBOARD_URL + `/dashboard/list_products`, param)
      .pipe(map(res => res), tap(err => this.spinnerService.hide(), () => this.spinnerService.hide()), catchError(this.handleError.bind(this)));
  }

  getDisplacementDetails(stockId): Observable<any> {    
    const param = {
      token: localStorage.getItem('token'),
      invoice_product_stock_id: stockId
    };
    return this.http.post(this.DASBOARD_URL + `/dashboard/displacement_details`, param);
  }

  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }

    console.error('server error:', error);
    
    // if (error.error instanceof Error) {
    //   const errMessage = error.error.message;
    //   return Observable.throw(errMessage);
    //   // Use the following instead if using lite-server
    //   // return Observable.throw(err.text() || 'backend server error');
    // }
    // return Observable.throw(error || 'Node.js server error');
  }

}
